import './select_view.js.coffee'
Namespace 'Customer.Filters'

class Customer.Filters.EditFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/edit_filter']
  className: 'customer-filters-edit modal-filters'

  events:
    'click input.array-option:checkbox': 'onClickCheckbox'
    'click span[data-toggle="button"]': 'onClickButton'
    'change .array-option': 'onOperatorAction'
    'change #users-list': 'onOperatorAction'
    'click .customRadio': 'onOperatorAction'
    'click .edit-filters-delete-button': 'onDelete'
    'click .edit-filters-cancel-button': 'closeModal'
    'click .edit-filters-save-button': 'onSave'

  initialize: (@options = {}) ->
    @socialAccounts = this.options.data.socialAccounts
    @availableFolders = @options.availableFolders
    @editable = @_isEditable()
    @modal =
      title: @_modalTitle()
    @data = @options.data || {}
    @newQuery = _.clone(@model._queryWithDefaults().get('query'))
    @newQuery.set = (key, value) -> @[key] = value
    @newQuery.get = (key) -> @[key]
    @_createTabViews()
    @tabsView = new Common.SimpleTabs.SimpleTabsView
      tabs: @_tabs()

  _isEditable: ->
    return false unless @model.isNew() or @model.get('is_editable')
    return @options.canManageGlobal if @model.isGlobal()
    @options.canManage

  _modalTitle: ->
    return I18n.t('customer.dashboard.filters.creation.header') if @model.isNew()
    return @model.get('name') unless @editable
    _.escape("#{I18n.t('customer.dashboard.filters.edition.header')} #{@model.get('name')}")

  _createTabViews: ->
    @_createGeneralTabView()
    @_createTicketTabView()
    @_createInteractionsTabView()
    @_createUsersTabView()
    @_createCustomAttributesTabView()

  _createGeneralTabView: ->
    @generalTabView = new Customer.Filters.EditFilterGeneralTabView
      filter: @model
      query: @model._queryWithDefaults()
      canManageGlobal: @options.canManageGlobal
      editable: @editable
      availableFolders: @availableFolders
      usersGroups: @data.users_groups
    @listenTo(@generalTabView, 'filter:toggleVisibility', @onToggleVisibility)

  _createTicketTabView: ->
    @ticketTabView = new Customer.Filters.EditFilterTicketTabView
      filter: @model
      statuses: @data.statuses
      allTypes: @allTypes()
      availableTypes: @availableTypes()
      editable: @editable
      userGroups: @data.users_groups
      groups: @data.groups
      users: @data.users

  _createInteractionsTabView: ->
    @interactionsTabView = new Customer.Filters.EditFilterInteractonsTabView
      filter: @model
      sentiments: @data.sentiments
      newQuery: @newQuery
      editable: @editable
      tags: @data.tags
    @listenTo(@interactionsTabView, 'sentiments:checkbox:clicked', @onClickCheckbox)

  _createUsersTabView: ->
    @usersTabView = new Customer.Filters.EditFilterUsersTabView
      users: @model._queryWithDefaults().get('query').users

  _createCustomAttributesTabView: ->
    @customAttributesTabView = new Customer.Filters.EditFilterCustomAttributesTabView
      customAttributes: @data.custom_attributes
      filter: @model
      editable: @editable

  _tabs: ->
    [@_generalTab(), @_ticketTab(), @_interactionsTab(), @_usersTab(), @_customAttributesTab()]

  _generalTab: ->
    id: 'general'
    title: I18n.t('customer.dashboard.filters.creation.general')
    contentView: @generalTabView

  _ticketTab: ->
    id: 'ticket'
    title: I18n.t('customer.dashboard.filters.creation.ticket')
    contentView: @ticketTabView

  _interactionsTab: ->
    id: 'interactions',
    title: I18n.t('customer.dashboard.filters.creation.interaction')
    contentView: @interactionsTabView

  _usersTab: ->
    id: 'user'
    title: I18n.t('customer.dashboard.filters.creation.users')
    contentView: @usersTabView

  _customAttributesTab: ->
    id: 'attributes'
    title: I18n.t('customer.dashboard.filters.creation.att')
    contentView: @customAttributesTabView

  render: ->
    @$el.html @template
      filter: @model._queryWithDefaults()
      data: @data
      shouldShowSaveButton: @_shouldShowSaveButton()
      shouldShowDeleteButton: @_shouldShowDeleteButton()
    @_renderTabs()
    @_setDefaultFilterVisibility()
    @_setReadOnlyMode() unless @editable
    @

  _setReadOnlyMode: ->
    @_hideEmpty()
    @$('.tab-content .tab-pane').addClass 'unclickable'

  _renderTabs: ->
    @_tabs().forEach (tab) -> tab.contentView.render()
    @$('.edit-filters-tabs-container').empty().append @tabsView.render().el

  _shouldShowSaveButton: ->
    @editable

  _shouldShowDeleteButton: ->
    @editable and not @model.isNew()

  onOperatorAction:->
    @_keepCustomerSessionAlive()

  allTypes: ->
    all_types = @options.data.all_types
    translated_all_types = _.mapObject(all_types, (v, k) =>
      @translate(v)
    )

  availableTypes: ->
    available_types = @options.data.available_types
    translated_available_types = _.mapObject(available_types, (v, k) =>
      @translate(v)
    )

  translate:(sub_types_array)->
    translated = {}
    _.each(sub_types_array, (sub_type)=>
      translated[sub_type] = I18n.t('monitoring.arrival_alerts.subtypes.only_subtypes.' + sub_type)
    )
    translated

  onDelete: =>
    @_keepCustomerSessionAlive()
    @trigger('delete', @model)
    @closeModal()

  onApply: =>
    @_updateAttrs()
    @closeModal()

  onSave: =>
    @_keepCustomerSessionAlive()
    @interactionsTabView.onApply()

    @_updateAttrs()
    @_cleanErrors()
    errors = @_filterIsValid()
    if errors.length == 0
      @model.update((filter) => @trigger('save', filter))
      @closeModal()
    else
      @_showErrors(errors)

  closeModal: (triggerKeepAlive) =>
    @_keepCustomerSessionAlive() if triggerKeepAlive
    @trigger 'modal:close'

  _updateAttrs: ->
    @_updateQuery()
    @_updateTags()
    @_updateGroups()
    @_updateCustomAttributeTags()
    @_updateTitle()
    @_updateAssignedTo()
    @_updateVisibleBy()
    @_updateVisibleByStatuses()
    @_updateDateRange()
    @_updateColor()
    @_updateFollowers()
    @_updateHasResponse()
    @_updateAppointments()
    @_updateUsers()
    @_updateFolder()
    @_updateVisibility()

  _updateVisibility: ->
    visibility = @generalTabView.getVisibility()
    @model.set('global', visibility['global'])
    @model.set('user_id', visibility['user_id'])

  _updateQuery: () ->
    @model.updateQuery(@newQuery)

  _updateTags: ->
    @interactionsTabView.updateTags()

  _updateGroups: ->
    @model.updateGroups([])
    @model.updateIntelligentGroups(@ticketTabView.getIntelligentGroups())

  _updateCustomAttributeTags: ->
    @customAttributesTabView.updateCustomAttributeTags()

  _updateTitle: ->
    @model.set('name', @generalTabView.getFilterTitle())

  _updateAssignedTo: ->
    @ticketTabView.updateAssignedTo()

  _updateVisibleBy: ->
    @model.updateVisibleBy(@generalTabView.getVisibleBy())

  _updateVisibleByStatuses: ->
    @model.updateVisibleByStatuses(@generalTabView.getVisibleByStatuses())

  _updateDateRange: ->
    {from, to} = @generalTabView.getDateRange()
    @model.updateDateRange(from, to)

  _updateColor: ->
    @model.updateColor(@generalTabView.getColor())

  _updateFollowers: ->
    @model.updateFollowers(@$el.find('.followers_min').val(), @$el.find('.followers_max').val())

  _updateUsers: ->
    users = @$('#users-list').val().split(',').map((user) -> user.trim())
    @model.updateUsers(users)

  _updateFolder: ->
    @model.set('old_filter_collection_id', @model.get('filter_collection_id'))
    filterFolderId = @generalTabView.getSelectedFolder()
    filterFolderId = null if filterFolderId == 'null'
    @model.updateFolder(filterFolderId)

  onClickCheckbox: (event) =>
    @_keepCustomerSessionAlive()
    tg = $(event.currentTarget)
    property = tg.data('property')
    value = tg.data('value')
    add = tg.prop('checked')
    @updateProperty(property, value, add)

  onClickButton: (event) =>
    @_keepCustomerSessionAlive()
    tg = $(event.currentTarget)
    property = tg.data('property')
    value = parseInt(tg.data('value'))
    add = !tg.hasClass('active')
    @updateProperty(property, value, add)

  updateProperty: (property, value, add) ->
    if add
      @newQuery[property].push(value)
    else
      @newQuery[property].remove(value)

  _hideEmpty: ->
    _.each(@$el.find('*[hide-if-empty]'), (el) =>
      el = $(el)
      prop = $(el).attr('hide-if-empty')
      if @model.get('query')[prop] && @model.get('query')[prop].length == 0
        el.hide()
    )
    $hrToHide = @$el.find('#hide-if-prev-is-hidden')
    $hrToHide.toggle(
      _.reduce(
        $hrToHide.prev().children(),
        (oneIsShown, el) ->
          oneIsShown || $(el).css('display') != 'none'
        , false)
    )

  _addSelectView: (selectView, element) ->
    @$el.find(element).append(selectView.el)
    @listenTo(selectView, 'change', @onSelectViewChange)
    selectView

  onSelectViewChange: ->
    @_keepCustomerSessionAlive()

  onToggleVisibility: (isGlobal) =>
    @trigger('filter:toggleVisibility', @model, isGlobal)

  _updateAppointments: ->
    @model.updateAppointments(@ticketTabView.getAppointments())

  _updateHasResponse: ->
    @model.updateHasResponse(@ticketTabView.getHasResponse())

  updateAvailableFolders: (folders) ->
    @availableFolders = folders
    @generalTabView.updateAvailableFolders(@availableFolders)

  _setDefaultFilterVisibility: ->
    if @$el.find('#visibility input:checked') == undefined
      input = @$el.find('#visibility input')[0]
      $(input).prop('checked', true)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _filterIsValid: ->
    errors = []

    errors.push('title') if @model.get('name') == ''

    followers = @model.get('query').followers
    errors.push('followers') if followers.min? && followers.max? && parseInt(followers.min) > parseInt(followers.max)

    errors

  _showErrors: (errors) ->
    if errors.includes('title')
      @generalTabView.showErrors(errors)
      @tabsView.showTab(@_generalTab().id)
    if errors.includes('followers')
      @errorNotification?.close()
      @ticketTabView.showErrors(errors)
      @errorNotification = showError(I18n.t('customer.dashboard.filters.creation.errors.followers'))

  _cleanErrors: ->
    @generalTabView.cleanErrors()
    @ticketTabView.cleanErrors()

  closeColorPicker: ->
    @generalTabView.closeColorPicker()
